<div id="unauthorized">
    <div class="unauthorized">
      <div class="unauthorized-401"></div>
      <h1>401</h1>
      <h2>{{ 'error.unauthorized.title' | translate }}</h2>
      <p>{{ 'error.unauthorized.message' | translate }}</p>
      <a href="/">{{ 'error.unauthorized.backToHome' | translate }}</a>
    </div>
  </div>